interface BoardConfigAdminFormLike {
    getRoot(): HTMLElement;
    getListEl(): HTMLElement | null;
}

interface BoardConfigAdminHandlerLike {
    handleListClick(event: MouseEvent): void;
    submitRow(event: SubmitEvent): Promise<void>;
}

export class BoardConfigAdminListener {
    public form: BoardConfigAdminFormLike;

    public handler: BoardConfigAdminHandlerLike;

    public constructor(form: BoardConfigAdminFormLike, handler: BoardConfigAdminHandlerLike) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        const root = this.form.getRoot();
        if (root.dataset.boardConfigsAdminBound === "1") {
            return;
        }

        root.dataset.boardConfigsAdminBound = "1";

        const listEl = this.form.getListEl();
        if (listEl instanceof HTMLElement) {
            listEl.addEventListener("click", (event) => this.handler.handleListClick(event));
            listEl.addEventListener("submit", (event) => {
                void this.handler.submitRow(event as SubmitEvent);
            });
        }
    }
}
